// @Library
import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit';

// @Utils
import { axiosEstimates } from '../../../utils/api';

// @Models
import { ITransportationRequest } from '../../../models';

// !--- INIT HANDLER ---!
const handleGetTransportation: AsyncThunkPayloadCreator<ITransportationRequest, undefined, {}> = async (
  payload,
  { rejectWithValue },
) => {
  try {
    const response = await axiosEstimates.get<ITransportationRequest>('transportation', {
      data: payload,
      headers: { 'x-module': 'services' },
    });

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response.data);
  }
};

// !--- END HANDLER ---!

// !--- INIT THUNKS ---!
export const getTransportations = createAsyncThunk('transportations/getTransportation', handleGetTransportation);
// !--- END THUNKS ---!
